import { fetchTranslationData } from "../../../services/translation/translation";
import { ServiceTranslation } from "../../../utils/constants";
import { useEffect, useState } from "react";

import { todayDate, getFormattedDate } from "../../../common/DateFormatters";
import SmsAlert from "./SmsAlert";

const QrCodeSms = ({ qrCodeValue, locale, dateModified }) => {
  const [translationMap, setTranslationMap] = useState(null);
  const [isValidDate, setIsValidDate] = useState(false);

  useEffect(() => {
    fetchTranslationData(ServiceTranslation.BloodDonation, locale).then((result) => {
      setTranslationMap(result);
    });
  }, [locale]);

  useEffect(() => {
    if (dateModified) {
      const modifiedDate = getFormattedDate(dateModified);
      const currentDate = getFormattedDate(new Date());
      if (modifiedDate === currentDate) {
        setIsValidDate(true);
      } else {
        setIsValidDate(false);
      }
    }
  }, [dateModified]);

  if (!isValidDate) {
    return (
      <SmsAlert />);

  }

  return (
    <>
             <section
        className="w-100 clearfix BloodDonationMainSection"
        id="CoverPlanActive">
        
                      <div className="container customContainer">
                        <div className="cover_inner_wrapper">
                          <div className="cover_main_box1">
                            <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible blood_barcode_alert_box">
                              <div className="Icon_box">
                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                <a href="javascript:void(0);">
                                  <span className="material-symbols-outlined">
                                    check_circle
                                  </span>
                                </a>
                              </div>
                              <div className="alert_text">
                                <h6>
                                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                  <a href="javascript:void(0);">
                                    {translationMap?.bloodDonationApproved}
                                  </a>
                                </h6>
                                <p className="number_txt">
                                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                  <a href="javascript:void(0);">
                                    {translationMap?.useQRCodeMsg}
                                  </a>
                                </p>
                              </div>
                            </div>
                            <div className="qr_code_questionnaire_wrap">
                              <div className="bd_summary_box">
                                <div className="bd_summary_text_box">
                                  <p className="date_text" style={{ direction: "ltr" }}>{todayDate()}</p>
                                  <p className="Gray_Title bottom_text bottom_text_italic">
                                    {translationMap?.codeValidToday}
                                  </p>
                                </div>
                                <div className="bd_summary_icon_box">
                                  <img
                      src={`data:image/png;base64,${qrCodeValue}`}
                      alt="Displaying barcode" />
                    
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="cover_main_box2"></div>
                        </div>
                      </div>
                    </section>
        </>);

};

export default QrCodeSms;